import { object, string, number } from 'yup'
import { CONNECTION_SHORT_NAME_MAX_LENGTH } from '../utils/shortNames'

export const connectionSchema = object({
  guid: string().default(''),
  name: string().required().default(''),
  short_name: string()
    .trim()
    .required('Bitte eine Kurzbezeichnung angeben')
    .max(CONNECTION_SHORT_NAME_MAX_LENGTH, `Höchstens ${CONNECTION_SHORT_NAME_MAX_LENGTH} Zeichen`)
    .default(''),
  export_comment: string().default(''),
  r_d_earthquake: number().moreThan(0).default(1000),
  r_d_wind: number().moreThan(0).default(1000),
})

/** `connectionSchema`, rejecting the short names other connectors already use. */
export const makeConnectionSchema = (takenShortNames: string[]) =>
  connectionSchema.shape({
    short_name: connectionSchema.fields.short_name.notOneOf(
      takenShortNames,
      'Diese Kurzbezeichnung wird bereits verwendet',
    ),
  })
